<template>
	<div>
		<el-card class="box-card">
			<div class="card-header">
				<el-form :label-width="200">
					<el-form-item :label="$t('group.select_device')" prop="imei">
						<el-input readonly v-model="imei" />
						<el-button @click="addDevice" type="primary">{{ $t('device.add') }}</el-button>
						<el-button @click="delDevice" type="primary">{{ $t('device.delete') }}</el-button>
					</el-form-item>
					<el-form-item :label="$t('notice.message')">
						<el-input :placeholder="$t('notice.input_message')" type="textarea" :rows="6"
							:show-word-limit="true" :maxlength="2000" v-model="content"></el-input>
						<el-button @click="load4G12Example" type="primary" size="small" style="margin-top: 10px;">4g12示例</el-button>
					<el-button @click="ttsDialog = true" type="primary" size="small" style="margin-top: 10px;">{{ $t('tts.title') }}</el-button>
					</el-form-item>
					<!-- 新增的三个单选控制组 -->
					<el-form-item :label="$t('notice.sound')">
						<el-radio-group v-model="sound">
							<el-radio :label="1">{{ $t('role.yes') }}</el-radio>
							<el-radio :label="0">{{ $t('role.no') }}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item :label="$t('notice.vibrate')">
						<el-radio-group v-model="vibrate">
							<el-radio :label="1">{{ $t('role.yes') }}</el-radio>
							<el-radio :label="0">{{ $t('role.no') }}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item :label="$t('notice.screen')">
						<el-radio-group v-model="screen">
							<el-radio :label="1">{{ $t('role.yes') }}</el-radio>
							<el-radio :label="0">{{ $t('role.no') }}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item>
						<el-button @click="handleSubmit" type="primary">{{ $t('notice.submit') }}</el-button>
						<!--            <el-button @click="resetForm" type="primary">重置</el-button>-->
					</el-form-item>
				</el-form>
			</div>
		</el-card>

		<!-- 设备选择对话框 -->
		<el-dialog :title="dialogTit" center v-model="addDialog" width="70%">
			<div style="padding-bottom:60px;">
				<el-form :model="addform" :inline="true" ref="searchForm">
					<el-form-item label="IMEI" prop="imei_keyword">
						<el-input :placeholder="$t('notice.enter_imei')" v-model="addform.imei_keyword"></el-input>
					</el-form-item>
					<el-form-item :label="$t('device.bind_name')" prop="name">
						<el-input v-model="addform.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('index.device_type')" prop="type">
						<el-select clearable :placeholder="$t('index.device_type')" v-model="addform.type">
							<el-option :key="item.value" :label="item.text" :value="item.value"
								v-for="item in deviceType"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('device.device_status')" prop="online">
						<el-select :placeholder="$t('device.device_status')" v-model="addform.online">
							<el-option :label="$t('index.online')" value="1"></el-option>
							<el-option :label="$t('index.offline')" value="0"></el-option>
							<el-option :label="$t('index.stripping_outline')" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('device.vesting')" prop="client_id">
						<el-cascader :options="clientData" :placeholder="$t('device.vesting')"
							v-model="addform.client_id"></el-cascader>
					</el-form-item>
					<el-form-item>
						<el-button @click="addSearch" type="primary">{{ $t('device.inquire') }}</el-button>
						<el-button @click="resetSearch">{{ $t('device.reset') }}</el-button>
						<el-button @click="handleAddDevice" type="primary">{{ $t('group.save') }}</el-button>
					</el-form-item>
				</el-form>
				<el-table :data="deviceData" @select="handleSelect" @select-all="handleSelectAll" ref="deviceTable">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column :label="$t('index.device')" property="imei" width="150"></el-table-column>
					<el-table-column :label="$t('index.device_type')" property="type"></el-table-column>
					<el-table-column :label="$t('device.device_status')" property="online"></el-table-column>
					<el-table-column :label="$t('device.bind_name')" property="name"></el-table-column>
					<el-table-column :label="$t('device.creation_time')" property="create_at"></el-table-column>
				</el-table>
				<el-pagination :page-size="addform.size" :total="addCount" @current-change="handleDeviceCurrentChange"
					@size-change="handleDeviceSizeChange" layout="total, prev, pager, next, jumper"></el-pagination>
			</div>
		</el-dialog>

		<!-- 文本转语音弹窗 -->
		<TtsDialog v-model="ttsDialog" />
	</div>
</template>
<script>
	import device from "../../model/device";
	import client from "../../model/client";
	import TtsDialog from "@/components/TtsDialog";

	/**
	 * 绑定实现：
	 * Step1.给table绑定多选框点击（select）事件
	 * Step2.根据选中数据的imei进行判断，存在则删除imei，不存在则push进选中的数组里-为了做分页时也能数据选中
	 * Step3.获取设备列表初始化表格之后判断imei通过toggleRowSelection设置是否选中
	 *        PS：注意需要表格初始化之后设置，通过setTimeout做异步处理
	 * Step4.新增和删除的时候将选中的设备列表赋给中间变量，为了做选中和提交的数据区分
	 *
	 * Remark selectDevice设备列表选中的数据
	 *        addform.imei 设备列表的筛选条件
	 */
	export default {
		name: "notice",
		components: { TtsDialog },
		data() {
			return {
				imei: '',
				content: '',
				ttsDialog: false,
				// 新增的三个控制变量
				sound: 1, // 默认响铃
				vibrate: 1, // 默认振动
				screen: 1, // 默认亮屏
				// 设备选择相关数据
				addform: {
					imei: "",
					name: "",
					imei_keyword: "",
					type: "",
					online: "",
					client_id: "",
					page: 1,
					size: 6
				},
				addCount: 0,
				addDialog: false,
				dialogTit: this.$t('group.add_device'),
				deviceType: [],
				deviceData: [],
				clientData: [],
				selectDevice: []
			}
		},
		async mounted() {
			await this.clientList();
			await this.deviceTypeArr();
		},
		methods: {
			load4G12Example() {
				const exampleData = [
					{
						"memoId": "12334",
						"startTime": "2025-02-24 10:00:00",
						"endTime": "2026-03-24 10:10:10",
						"title": "路基清表2025-02-24 10:00:00",
						"emerg": [
							{
								"audio": "https://cms.kaiot.top/application/web/4g12.mp3",
								"title": "潜在事故类型",
								"content": "1、车辆伤害\n2、机械伤害"
							}
						],
						"riskInfo": [
							{
								"audio": "https://cms.kaiot.top/application/web/4g12.mp3",
								"title": "风险描述",
								"content": "1、沟/坑/隐井未防护，产生坠落伤害；\n2、地下管线不明，产生挖损泄漏/触电；"
							}
						],
						"jobKey": [
							{
								"audio": "https://cms.kaiot.top/application/web/4g12.mp3",
								"title": "1",
								"content": "1、三级教育考核合格，年龄18-60岁，无不适合劳动的疾病；2、作业时佩戴安全帽、反光服、劳保鞋、防尘口罩、防护手套；"
							}
						]
					}
				];
				this.content = JSON.stringify(exampleData);
			},
			async clientList() {
				const ret = await client.list();
				if (ret.code === 200) {
					this.clientData = this.handleClientTree(ret.data)
				}
			},
			handleClientTree(data) {
				if (data.length === 0) {
					return []
				}
				let options = []
				data.forEach(item => {
					options.push({
						value: item.id,
						label: item.name
					})
					if (item.children.length > 0) {
						options.push({
							value: item.id,
							label: item.name,
							children: this.handleClientTree(item.children)
						})
					}
				})
				return options
			},
			async deviceTypeArr() {
				const ret = await device.config();
				if (ret.code === 200) {
					this.deviceType = ret.data;
				}
			},
			async deviceList() {
				const ret = await device.group(this.addform);
				if (ret.code === 200) {
					this.deviceData = ret.data.list;
					this.addCount = ret.data.count;
					setTimeout(() => {
						this.deviceData.forEach(v => {
							this.$refs.deviceTable.toggleRowSelection(
								v,
								this.selectDevice.indexOf(v.imei) > -1
							);
						});
					});
				}
			},
			addDevice() {
				this.addDialog = true;
				this.dialogTit = this.$t('group.add_device');
				this.selectDevice = this.imei ? this.imei.split(',') : [];
				this.addform.imei = "";
				this.addform.imei_keyword = "";
				this.deviceList();
			},
			delDevice() {
				this.addDialog = true;
				this.dialogTit = this.$t('group.delete_device');
				this.selectDevice = this.imei ? this.imei.split(',') : [];
				this.addform.imei_keyword = ''
				this.addform.imei = this.selectDevice.length == 0 ? [''] : this.selectDevice.join(",");
				this.deviceList();
			},
			handleAddDevice() {
				this.imei = this.selectDevice.join(",");
				this.addDialog = false;
			},
			handleSelect(selection, row) {
				const index = this.selectDevice.indexOf(row.imei);
				if (index > -1) {
					this.selectDevice.splice(index, 1);
				} else {
					this.selectDevice.push(row.imei);
				}
			},
			handleSelectAll(selection) {
				if (selection.length === 0) {
					this.deviceData.forEach(v => {
						let index = this.selectDevice.indexOf(v.imei);
						if (index > -1) {
							this.selectDevice.splice(index, 1);
						}
					})
				} else {
					this.deviceData.forEach(v => {
						let index = this.selectDevice.indexOf(v.imei);
						if (index < 0) {
							this.selectDevice.push(v.imei);
						}
					})
				}
			},
			addSearch() {
				this.deviceList();
			},
			resetSearch() {
				this.$refs.searchForm.resetFields();
				this.deviceList();
			},
			handleDeviceSizeChange(val) {
				this.addform.size = val;
				this.deviceList();
			},
			handleDeviceCurrentChange(val) {
				this.addform.page = val;
				this.deviceList();
			},
			async handleSubmit() {
				// 检查是否是4g12类型的JSON数据（尝试解析为JSON数组）
				let finalContent;
				try {
					const parsedContent = JSON.parse(this.content);
					if (Array.isArray(parsedContent)) {
						// 如果是数组，包装成 {"content":"原JSON字符串","sound":1,"vibrate":1,"screen":1} 格式
						finalContent = JSON.stringify({
							content: this.content,
							sound: this.sound,
							vibrate: this.vibrate,
							screen: this.screen
						});
					} else {
						// 如果是对象，按原来的格式处理
						const noticeData = {
							content: this.content,
							sound: this.sound,
							vibrate: this.vibrate,
							screen: this.screen
						};
						finalContent = JSON.stringify(noticeData);
					}
				} catch (e) {
					// 解析失败，按原来的格式处理
					const noticeData = {
						content: this.content,
						sound: this.sound,
						vibrate: this.vibrate,
						screen: this.screen
					};
					finalContent = JSON.stringify(noticeData);
				}

				const params = {
					imei: this.imei,
					content: finalContent
				};

				const ret = await device.notice(params);
				if (ret.code === 200) {
					this.imei = ''
					this.content = ''
					// 重置选项为默认值
					this.sound = 1;
					this.vibrate = 1;
					this.screen = 1;
					this.$message.success(ret.message);
					this.toNoticeList();
				} else {
					this.$message.error(ret.message);
				}
			},
			toNoticeList() {
				this.$router.push({
					path: "/device/noticeList"
				});
			}
		}
	};
</script>
<style scoped>
	.el-dialog::v-deep .el-dialog__body {
		padding-bottom: 100px !important;
	}

	.card-header .el-form-item__content {
		display: flex !important;
	}

	.card-header .el-form-item__label {
		float: left;
	}

	.el-button {
		margin-left: 10px;
	}
</style>